import axiosClient from "./axiosClient";

const serviceUrl = "/qlttbhyt-service/thanh-toan";

const payService = {
  getListPatient: async (page, limit) => {
    const url = serviceUrl + `/lan-kham`;
    const params = { page: page, limit: 10 };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  getPatientById: async (id) => {
    const params = { id: id };
    const url = serviceUrl + `/lan-kham`;
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  addPatientById: async () => {
    const params = { id: null };
    const url = serviceUrl + `/lan-kham`;
    const response = await axiosClient.post(url, { params: params });
    return response;
  },

  updatePatientById: async (id, body) => {
    const url = serviceUrl + `/lan-kham?id=${id}`;
    const response = await axiosClient.put(url, body);
    return response;
  },

  searchPatient: async (body, param) => {
    const url = `qlttbhyt-service/lan-kham/search`;
    const response = await axiosClient.post(url, body, { params: param });
    return response;
  },

  deletePatient: async (id) => {
    const url = serviceUrl + `/lan-kham`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response;
  },

  getListPrepay: async () => {
    const url = serviceUrl + "/tam-ung";
    const response = await axiosClient.get(url);
    return response;
  },

  getDetailPrepayById: async (id) => {
    const url = serviceUrl + "/tam-ung";
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  getListPrepayId: async (id, page) => {
    const url = serviceUrl + "/danh-sach-tam-ung-by-id-lan-kham";
    const params = { idlankham: id, page: page, limit: 10 };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  addPrepay: async (params) => {
    const url = serviceUrl + "/tam-ung";
    const response = await axiosClient.post(url, params);
    return response;
  },

  updatePrepay: async (id, body) => {
    const url = serviceUrl + `/tam-ung?id=${id}`;
    const response = await axiosClient.put(url, body);
    return response;
  },

  deletePrepay: async (id) => {
    const url = serviceUrl + `/tam-ung`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response;
  },

  submitPrepay: async (body) => {
    const url = serviceUrl + `/duyet-by-list-id`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  submitPrepayById: async (body) => {
    const url = serviceUrl + `/tam-ung`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  getListCancelPay: async (page) => {
    const url = serviceUrl + `/huy-thanh-toan`;
    const params = { page: page, limit: 10 };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  getListDetailPay: async (id) => {
    const url = serviceUrl + `/thong-ke-chi-tiet-thanh-toan`;
    const params = { idlankham: id };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  getListDetailPrepay: async (id) => {
    const url = serviceUrl + `/tong-tam-ung`;
    const params = { idlankham: id };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  getListCancelPayById: async (id, page,limit) => {
    const url = serviceUrl + `/danh-sach-huy-thanh-toan-by-id-lan-kham`;
    const params = { idlankham: id, page: page, limit: limit };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  postListDetailPay: async (body) => {
    const url = serviceUrl + `/thong-ke-chi-tiet-thanh-toan`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  getListDetailPayById: async (id, type) => {
    const url = serviceUrl + `/danh-sach-chi-dinh-by-id-lan-kham`;
    const params = { idlankham: id, page: 1, limit: 1000, type: type };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  deleteDetailPayById: async (id) => {
    const url = serviceUrl + `/thanh-toan`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response;
  },

  getListPrescriptionById: async (id) => {
    const url = serviceUrl + `/danh-sach-don-thuoc-by-id-thanh-toan`;
    const params = { idthanhtoan: id };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  getListRefundsById: async (id, page, limit) => {
    const url = serviceUrl + `/danh-sach-hoan-phi-by-id-lan-kham`;
    const params = { idlankham: id, page: page, limit: limit };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  getDetailRefunds: async (id) => {
    const url = serviceUrl + `/thong-ke-chi-tiet-thanh-toan`;
    const params = { idlankham: id };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  suggestionRefunds: async (body) => {
    const url = serviceUrl + `/de-nghi-hoan-phi-by-list-id`;
    const response = await axiosClient.post(url, body);
    return response.data;
  },

  cancelRefunds: async (body) => {
    const url = serviceUrl + `/huy-hoan-phi-by-list-id`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  submitRefundsById: async (body) => {
    const url = serviceUrl + `/duyet-hoan-phi-by-list-id`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  getListExemptions: async (page) => {
    const url = serviceUrl + `/mien-giam`;
    const params = { page: page, limit: 10 };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  getListExemptionsById: async (id, page) => {
    const url = serviceUrl + `/danh-sach-mien-giam-by-id-lan-kham`;
    const params = { idlankham: id, page: page, limit: 10 };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  addExemptionsById: async (id, body) => {
    const url = serviceUrl + `/mien-giam?id=${id}`;
    // const params = {idlankham: id};
    const response = await axiosClient.put(url, body);
    return response;
  },

  addSuggestionExemptions: async (body) => {
    const url = serviceUrl + `/mien-giam`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  editSuggestionExemptions: async (id, body) => {
    const url = serviceUrl + `/mien-giam?id=${id}`;
    const response = await axiosClient.put(url, body);
    return response;
  },

  deleteSuggestionExemptions: async (id) => {
    const url = serviceUrl + `/mien-giam`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response;
  },

  getDetailExemptions: async (id) => {
    const url = serviceUrl + `/thong-ke-chi-tiet-thanh-toan`;
    const params = { idlankham: id };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  getListRefundsTabDetail: async () => {
    const url = serviceUrl + `/danh-sach-hoan-tra`;
    const response = await axiosClient.get(url);
    return response;
  },
  searchRefundsTabDetail: async (body) => {
    const url = `qlttbhyt-service/danh-sach-hoan-tra/search`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  getListExemptionsTabDetail: async () => {
    const url = serviceUrl + `/danh-sach-mien-giam`;
    const response = await axiosClient.get(url);
    return response;
  },

  addExemptionsById: async (body) => {
    const url = serviceUrl + `/mien-giam-theo-chi-dinh`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  searchExemptionsTabDetail: async (body) => {
    const url = `/qlttbhyt-service/danh-sach-mien-giam/search?page=1&?limit=10`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  getListPaidTabDetail: async () => {
    const url = serviceUrl + `/da-thanh-toan`;
    const response = await axiosClient.get(url);
    return response;
  },

  searchPaidTabDetail: async (body) => {
    const url = `/qlttbhyt-service/da-thanh-toan/search?page=1&?limit=10`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  deletePaidDetail: async (id) => {
    const url = serviceUrl + `/da-thanh-toan`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response;
  },

  getActionCancelPay: async (body) => {
    const url = serviceUrl + `/huy-by-list-id`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  getActionSuccessPay: async (body) => {
    const url = serviceUrl + `/hoan-thanh-by-list-id`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  getHistoryPay: async (id, page) => {
    const url = serviceUrl + `/lich-su-thanh-toan`;
    const params = { idlankham: id, page: page, limit: 10 };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  saveHistoryPay: async (body) => {
    const url = `/qlttbhyt-service/thanh-toan/lich-su-thanh-toan`;
    const response = await axiosClient.put(url, body);
    return response;
  },

  getDataPayPrint: async (body) => {
    const url = serviceUrl + `/phieu-thu-tien`;
    const response = await axiosClient.post(url, body);
    return response;
  },
  getPhieuThuLePrint: async (id) => {
    const url = serviceUrl + `/phieu-thu-le?id=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },

  getDataPayPrintPerson: async (id) => {
    const url = serviceUrl + `/hoa-don-ca-nhan?idlankham=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },

  getDataPatientCard: async (id) => {
    const url = serviceUrl + `/the-kham-benh-nhan?idbenhnhan=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },

  updatePatientCard: async (id) => {
    const url = serviceUrl + `/update-the-benh-nhan?idchidinh=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },

  updateBHCard: async (id) => {
    const url = serviceUrl + `/update-the-bao-hiem?idchidinh=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },

  getDataPrintPrepay: async (body) => {
    const url = serviceUrl + `/phieu-tam-ung`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  getDataPrintRefunds: async (body) => {
    const url = serviceUrl + `/giay-de-nghi-hoan-phi`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  getRenderXMLData: async (param) => {
    const url = `/qlttbhyt-service/ket-xuat`;
    const response = await axiosClient.get(url, { params: param });
    return response;
  },

  getDataExportXML: async (param) => {
    const url = `/qlttbhyt-service/ket-xuat/export-to-excel`;
    const response = await axiosClient.get(url, {
      params: param,
      responseType: "blob",
    });
    return response;
  },
  //c79
  getDataExportXMLPDF: async (param) => {
    const url = `/qlttbhyt-service/ket-xuat/export-to-pdf`;
    const response = await axiosClient.get(url, {
      params: param,
      responseType: "blob",
    });
    return response;
  },

  //pdf c80
  getDataExportXMLPDFC80: async (param) => {
    const url = `/qlttbhyt-service/day-du-lieu/bieu-mau-c80`;
    const response = await axiosClient.get(url, {
      params: param,
      responseType: "blob",
    });
    return response;
  },

  //excel
  getDataExportXMLExcelC80: async (param) => {
    const url = `/qlttbhyt-service/day-du-lieu/export-excel-bieu-mau-c80`;
    const response = await axiosClient.get(url, {
      params: param,
      responseType: "blob",
    });
    return response;
  },

  getPushXMLData: async (param) => {
    const url = `/qlttbhyt-service/day-du-lieu/ds-benh-nhan`;
    const response = await axiosClient.get(url, { params: param });
    return response.data;
  },
  pushXMLData: async (data) => {
    const url = `/qlttbhyt-service/day-du-lieu/day-xml`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  //kiêm tra dữu liệu xml
  checkXMLData: async (data) => {
    const url = `/qlttbhyt-service/day-du-lieu/check-loi`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  getDataExportPushXML: async (param) => {
    const url = `/qlttbhyt-service/day-du-lieu/export-to-excel`;
    const response = await axiosClient.get(url, {
      params: param,
      responseType: "blob",
    });
    return response;
  },

  getDataReportPay: async (param) => {
    const url = `/qlttbhyt-service/thanh-toan/lan-kham/bao-cao-doanh-thu`;
    const response = await axiosClient.get(url, { params: param });
    return response;
  },

  getDataReportPayNew: async (param) => {
    const url = `/qlttbhyt-service/thanh-toan/lan-kham/bao-cao-doanh-thu-new`;
    const response = await axiosClient.get(url, { params: param });
    return response;
  },

  getExportReportPayNew: async (param) => {
    const url = `/qlttbhyt-service/thanh-toan/lan-kham/export-bao-cao-doanh-thu-new`;
    const response = await axiosClient.get(url, {
      params: param,
      responseType: "blob",
    });
    return response;
  },

  getExportReportPay: async (param) => {
    const url = `/qlttbhyt-service/thanh-toan/lan-kham/export-bao-cao-doanh-thu`;
    const response = await axiosClient.get(url, {
      params: param,
      responseType: "blob",
    });
    return response;
  },

  getListDMDV: async () => {
    const url = `/qlkhambenh/dm-nhom-dich-vu/list-dm-nhom-dich-vu`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListSearchDMDV: async (id) => {
    const url = `/qlkhambenh/dm-dich-vu/search-dm-dich-vu`;
    const params = { idNhomDichVu: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getDvByListDMDV: async (id) => {
    const url = `/qlkhambenh/dm-dich-vu/get-by-id-nhom-dich-vu`;
    const params = { idNhomDichVu: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },

  getDataBangKe: async (id, coPhuThu) => {
    const url = `/qlttbhyt-service/thanh-toan/bang-ke`;
    const params = { idPhieuKham: id, coPhuThu: coPhuThu };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  getListNv: async () => {
    const url = `/qlttbhyt-service/thanh-toan/nhan-vien-thu-nhan`;
    const response = await axiosClient.get(url);
    return response.data;
  },

  getDataPrintPPT: async (list) => {
    const url = `/qlttbhyt-service/thanh-toan/phieu-phu-thu-in?phieuTamUngs=${list}`;
    const response = await axiosClient.get(url);
    return response;
  },

  getDataPrintPTT: async (params, value) => {
    const queryParams = params.map((id) => `idChiDinhs=${id}`).join("&");
    const url = `/qlttbhyt-service/thanh-toan/phieu-thu-tien?tongTienMienGiam=${value}&${queryParams}`;
    const response = await axiosClient.get(url);
    return response;
  },
  //Xuất excel bảng kê
  getExportBangKe: async (param) => {
    const url = `/qlttbhyt-service/thanh-toan/export-bang-ke`;
    const response = await axiosClient.get(url, {
      params: param,
      responseType: "blob",
    });
    return response;
  },
};

export default payService;
